var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.67 191.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fc1503;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.13,71.6q-28.23,0-56.45,0-28,0-55.94,0c-7.05,0-8.64,1.51-8.65,8.38q0,41.21,0,82.42c0,7,1.61,8.58,8.5,8.59q56.19,0,112.39,0c6.51,0,8.43-1.86,8.43-8.19q0-41.46,0-82.92C160.41,73.4,158.59,71.6,152.13,71.6Zm-106,12.51C43.07,84,43.32,82,43.6,80c1.93-1.52,3.83-1.68,5.69.11C49.78,82.64,49.17,84.24,46.12,84.11Zm69,73.61a3.88,3.88,0,0,1-4-4.18c0-2.48,1.48-4,4-4.29,2.46.24,4.2,1.52,4.34,4A4,4,0,0,1,115.1,157.72Zm12.76-.05c-2.73.12-4.37-1.59-4.34-4.34a3.8,3.8,0,0,1,4.17-4c2.49,0,3.9,1.58,4.21,4.07C131.71,155.94,130.29,157.57,127.86,157.67Zm16.47-3.73c-.22,2.43-2,3.59-4.39,3.9-2.46-.66-4.27-2.07-4-4.77a4.21,4.21,0,0,1,8.38.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.66,0a33.3,33.3,0,1,0,.21,66.6,33.07,33.07,0,0,0,32.89-33.21C135.69,14.59,121.22,0,102.66,0Zm-.12,37.34a3.78,3.78,0,0,1-4-4.07c0-2.6,1.62-4.4,4.43-4.17,2.47.2,3.79,1.77,3.77,4.34C106.51,36,105,37.37,102.54,37.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.12,67C22.79,68.11,10.39,55,10.67,40.35c.27-14.81,10.87-26.66,26.5-26.67,15.29,0,27.07,11.48,27.46,26.25C65,54.44,51.53,68.41,38.12,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.64,158.73c-8.48-2.43-16.44-4.77-24.44-7-2-.54-2.07-1.8-2.06-3.37q0-27,0-54c0-2.08.43-3.27,2.77-3.87,7.08-1.83,14.1-3.91,21.1-6,2-.61,2.68-.3,2.68,1.85C238.63,110.31,238.64,134.27,238.64,158.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.57,121.06c0,6.8-.1,13.62.05,20.42,0,2.72-.4,4-3.54,3.22-6.6-1.64-13.24-3.15-19.91-4.47-2.4-.47-3.3-1.39-3.27-3.89.12-10.13.09-20.26,0-30.39,0-1.85.29-3,2.48-3.49q10.73-2.17,21.37-4.76c2.46-.6,2.82.35,2.8,2.43C207.53,107.1,207.57,114.08,207.57,121.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.11,176.09c-8.4,5.33-15.81,10-23.18,14.73a7.48,7.48,0,0,1-4.3.91c-14.64,0-29.27-.06-43.9,0-3.16,0-5-.52-4.93-4.32,0-3.61,1.4-4.49,4.75-4.45,13.63.14,27.27,0,40.9.08A11.51,11.51,0,0,0,61,181.32C71.24,174.84,71.4,174.85,85.11,176.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.47,91.68c.54-3.42-2-9.17,1.07-11.43,2.48-1.84,7.91.18,12,.69,12,1.48,12,1.52,12,13.43a23.74,23.74,0,0,0,0,3.48c.47,3.07-.69,4.43-3.85,4.72-5.94.55-11.87,1.24-17.75,2.22-3.16.53-3.67-.69-3.5-3.37C.6,98.44.47,95.45.47,91.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.5,121.52V127c0,9.05,0,8.91-9.08,7.86-3.3-.38-4.52-1.5-4.35-4.94.3-6,.24-12,0-17.94-.1-2.75.81-3.71,3.51-4.1,9.91-1.42,9.89-1.52,9.88,8.65Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a67d814f527ec7fae16f69077de70ba6.svg";
export { ForwardRef as ReactComponent };